export enum CurrencyPosition {
  "before" = "before",
  "after" = "after",
}
